import Tooltip from "@material-ui/core/Tooltip";
import React from "react";
import { IDisplayState } from "../../interfaces/IDisplayState";
import UserService from "../../utilities/userService";
import Icon from "../icon/icon";

export interface IAccountInfoProps {
  isLoggedInOrCookied: boolean;
  hasMultipleAccounts: boolean;
  mobileMenu?: boolean;
  displayAccountName: boolean;
  customerAccountName: string;
  accountNumber: string;
  displayState: IDisplayState;
  switchAccountHref: string;
  gsaLinkText: string;
  gsaHref: string;
  userConfigId?: string;
}

const AccountInfo = (props: IAccountInfoProps) => {
  const welcomeToWb = (
    <span className="welcome-message">Welcome to W.B. Mason</span>
  );

  const hiddenAccountNumberElement = (
    <div id="wbm_account_number">{props.accountNumber}</div>
  );

  const mobileMenuClassName = () => {
    if (!props.isLoggedInOrCookied) {
      return "col-12";
    } else {
      if (!props.hasMultipleAccounts) {
        return "col-12 user-info-col";
      } else {
        return "col-8 user-info-col";
      }
    }
  };

  return (
    <React.Fragment>
      <div className={!props.mobileMenu ? "" : "bg-gray row"}>
        <div className={!props.mobileMenu ? "" : mobileMenuClassName()}>
          <span>
            {props.isLoggedInOrCookied && props.userConfigId && (
              <span>
                <span className={!props.mobileMenu ? "" : "mobile-user-info"}>
                  {!props.mobileMenu ? (
                    UserService.displayUserInfo() ? (
                      <>
                        <span>Shopping For</span>{" "}
                      </>
                    ) : (
                      welcomeToWb
                    )
                  ) : (
                    <>{UserService.displayUserInfo() ? <></> : welcomeToWb}</>
                  )}
                  {UserService.displayUserInfo() && (
                    <>
                      {props.displayAccountName && (
                        <>
                          <span
                            className={
                              !props.mobileMenu ? "font-weight-bold" : ""
                            }
                          >
                            {props.customerAccountName}
                          </span>{" "}
                        </>
                      )}
                      ({props.accountNumber}
                      {props.displayState.accountGroupName
                        ? " - " + props.displayState.accountGroupName
                        : ""}
                      )
                    </>
                  )}
                </span>
                {!props.mobileMenu && props.hasMultipleAccounts && (
                  <Tooltip arrow placement={"bottom"} title="Switch Account">
                    <a
                      className={`switch-account-wrapper ${
                        props.switchAccountHref ? "active" : ""
                      }`}
                      href={props.switchAccountHref}
                    >
                      <Icon className="switch-account align-middle">
                        swap_horizontal_circle
                      </Icon>
                    </a>
                  </Tooltip>
                )}
              </span>
            )}
            {!props.isLoggedInOrCookied && welcomeToWb}
            {!props.isLoggedInOrCookied && props.gsaLinkText && (
              <span>
                {"  |  "}
                <a
                  className={`fed-gov-cust ${props.gsaHref ? "active" : ""}`}
                  href={props.gsaHref}
                  dangerouslySetInnerHTML={{ __html: props.gsaLinkText }}
                ></a>
              </span>
            )}
          </span>
        </div>
        {props.mobileMenu &&
          props.isLoggedInOrCookied &&
          props.hasMultipleAccounts && (
            <div className={"col-4 switch-account-col"}>
              <a
                className="switch-account-wrapper mobile"
                href={props.switchAccountHref}
              >
                <Icon className="switch-account align-middle mr-2">
                  swap_horizontal_circle
                </Icon>
                <span className="switch-account-text">Switch Account</span>
              </a>
            </div>
          )}
        {hiddenAccountNumberElement}
      </div>
    </React.Fragment>
  );
};

export default AccountInfo;
